<template>
  <div>
    <b-row>
      <b-col>
        <div>
          <main-title title="Seleccione el tipo de envío" />
          <b-row class="mx-0 mb-2">
            <b-col>
              <b-form-radio
                v-model="formData.deliverytype"
                name="deliverytype"
                value="1"
                @change="stepready = false; showForm = false"
                >Quiero que me lo envíen</b-form-radio
              >
            </b-col>
            <b-col>
              <b-form-radio
                v-model="formData.deliverytype"
                name="deliverytype"
                value="2"
                @change="formData.type = { id: -1, cost: 0 }; stepready = true"
                >Lo voy a retirar del local</b-form-radio
              >
            </b-col>
          </b-row>
          <b-row class="m-0" v-if="formData.deliverytype === '1'">
            <b-col class="col-12 col-md-9">
              <b-row>
                <b-col>
                  <label>Dirección de entrega (calle y número)</label>
                  <autocomplete :initvalue="formData.addresscords.text" @address-change="setAddresscords($event)" />
                </b-col>
              </b-row>
              <b-row class="pt-0 pt-md-2">
                <b-col class="col-12 col-md-6">
                  <b-form-group
                    label="Piso / Departamento"
                    label-for="addressdetails"
                    class="mt-2 mt-md-0"
                  >
                    <b-form-input
                      id="addressdetails"
                      v-model="formData.addressdetails"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col class="col-12 col-md-6">
                  <b-form-group
                    label="Código Postal"
                    label-for="addresscp"
                  >
                    <b-form-input
                      id="addresscp"
                      v-model="formData.addresscp"
                      trim
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="col-12 col-md-3 pt-0 pt-md-4">
              <b-button @click="calcularentrega()" class="mt-0 mt-md-2 mb-0 mb-2"
                >Calcular entrega</b-button
              >
            </b-col>
          </b-row>
        </div>
        <div v-if="showForm && formData.deliverytype === '1'">
          <b-row class="m-0">
            <b-col>
              <b-alert show class="mt-2 mt-md-0">
                En base a la información sumistrada detectamos que se encuentra
                en {{ addressInfo.localidad }} <span v-if="addressInfo.cpostal">(Código postal {{addressInfo.cpostal}})</span> {{ addressInfo.provincia }}
                {{ addressInfo.pais }} a {{ addressInfo.distance }} km de la
                librería. <br />Si esta información no es correcta, por favor
                vuelva a realizar la busqueda en el cuadro superior.
              </b-alert>
            </b-col>
          </b-row>
          <b-row class="m-0">
            <b-col>
              <b-form-group label="Tipo de envío" label-for="shiptype">
                <b-form-select
                  id="shiptype"
                  v-model="formData.type"
                  :options="shipTypeList"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="m-0">
            <b-col class="col-12 col-md-4">
              <b-form-group label="Nombre de quien recibe" label-for="name">
                <b-form-input
                  id="name"
                  v-model="formData.name"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col class="col-12 col-md-4">
              <b-form-group label="Documento de quien recibe" label-for="dni">
                <b-form-input
                  id="dni"
                  v-model="formData.dni"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col class="col-12 col-md-4">
              <b-form-group label="Teléfono de quien recibe" label-for="phone">
                <b-form-input
                  id="phone"
                  v-model="formData.phone"
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="m-0">
            <b-col>
              <small
                >Las opciones se han limitado en función de la dirección
                ingresada</small
              >
            </b-col>
          </b-row>
        </div>

        <b-row class="m-0">
          <b-col>
            <div style="font-size: x-large; margin-bottom: .25rem;">
              A quién le va a llegar este libro
            </div>
          </b-col>
        </b-row>
        <b-row class="mx-0 mb-2">
          <b-col>
            <b-form-radio v-model="formData.isGift" name="isGift" :value="false"
              >Lo compro para mí</b-form-radio
            >
          </b-col>
          <b-col>
            <b-form-radio v-model="formData.isGift" name="isGift" :value="true"
              >Es un regalo</b-form-radio
            >
          </b-col>
        </b-row>
        <b-row class="mx-0 mb-2" v-if="formData.isGift">
          <b-col>
            <b-form-group
              label="Escriba el mensaje que llevará el regalo"
              label-for="giftMessage"
            >
              <b-form-textarea
                id="giftMessage"
                v-model="formData.giftMessage"
                placeholder="Escriba algo..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="col-12 col-md-3">
        <div
          class="d-flex flex-column justify-content-between p-4"
          style="background: #F1F1F1; font-family: 'Poppins', sans-serif; border-radius: 2rem; min-height: 100%;"
        >
          <div>
            <div style="margin-top: -3rem;">
              <main-title title="Detalle" />
            </div>
            <b-list-group flush style="font-size: small;">
              <b-list-group-item
                class="d-flex pt-4 px-0 border-bottom-0"
                style="background-color: transparent;"
              >
                <div>Su compra</div>
                <div class="ml-auto" style="font-weight: bold;">$ {{ calcSubtotal() + discounts }}</div>
              </b-list-group-item>
              <b-list-group-item
                class="d-flex px-0 pt-0 border-bottom-0"
                style="background-color: transparent; font-size: .7rem;"
                v-if="discounts > 0"
              >
                <div class="ml-3">Descuentos</div>
                <div class="ml-auto" style="font-weight: bold;">- $ {{discounts}}</div>
              </b-list-group-item>

              <b-list-group-item
                class="d-flex px-0 pt-0"
                style="background-color: transparent; font-size: .7rem;"
              >
                <div class="ml-3">Peso total</div>
                <div class="ml-auto" style="font-weight: bold;">{{shipWeight}} gr</div>
              </b-list-group-item>
              
              <b-list-group-item
                class="d-flex px-0"
                style="background-color: transparent;"
              >
                <div>Valor del envío</div>
                <div v-if="!showForm && formData.deliverytype === '1'" class="ml-auto" style="font-weight: bold;">
                  $ -
                </div>
                <div v-else class="ml-auto" style="font-weight: bold;">
                  $ {{ formData.type.cost }}
                </div>
              </b-list-group-item>
              <!-- 
              <b-list-group-item
                class="d-flex px-0"
                style="background-color: transparent;"
              >
                <div>Descuentos</div>
                <div class="ml-auto" style="font-weight: bold;">{{discounts}} %</div>
              </b-list-group-item> -->
              
              <b-list-group-item
                class="d-flex pt-4 px-0"
                style="font-weight: bold; background-color: transparent;"
              >
                <div>Total</div>
                <div class="ml-auto">$ {{ calcSubtotal() + formData.type.cost }}</div>
              </b-list-group-item>
            </b-list-group>
          </div>
        </div>
      </b-col>
    </b-row>
    <div class="d-flex mx-2 mb-2 mt-4">
      <div
        class="rounded py-2 px-4 d-flex justify-content-between flex-fill subtotal-line"
        style="background: #f1f1f1;"
      >
        <div>Total</div>
        <div class="d-none d-md-block">{{ cart }} items</div>
        <div>${{ calcSubtotal() + formData.type.cost }}</div>
      </div>
      <b-button
        size="sm"
        class="ml-3"
        style="background: #e8661a; border:none; line-height: 2rem; font-size: 1em;"
        @click="saveData()"
        :disabled="!stepready"
        >Siguiente</b-button
      >
    </div>
  </div>
</template>
<script>
import Autocomplete from "@/components/GoogleAutocomplete.vue";
import MainTitle from "@/components/MainTitle.vue";
import axios from "axios";
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    Autocomplete,
    MainTitle
  },
  data: function() {
    return {
      formData: {
        name: "",
        addresscords: {},
        addressdetails: "",
        addresscp: "",
        dni: "",
        phone: "",
        discount: "",
        giftMessage: "",
        isGift: false,
        deliverytype: "1",
        type: {id: 0, cost: 0}
      },
      shipTypeList:[],

      showForm: false,
      stepready: false,
      
      shipCost: 0,
      shipWeight: 0,
      discounts: 0,
      addressInfo: {
        distance: 0,
        localidad: "",
        pais: "",
        provincia: "",
        cpostal: ""
      }
    };
  },
  computed: {
    ...mapState({
      cartItems: state => state.cart.cartItems
    }),
    ...mapGetters({ cart: "countCartItems" })
  },
  mounted(){
    if (this.$parent.formData.step1){
      this.shipWeight = this.$parent.formData.step1.peso;
      // this.discounts = Math.round( (this.$parent.formData.step1.discounts * 100) /  this.$parent.formData.step1.precio )
      this.discounts = this.$parent.formData.step1.discounts;
    }else{
     this.$router.push('/cart/step1');
    }
    if (this.$parent.formData.step2){
      this.formData.addresscords = Object.assign({},this.$parent.formData.step2.addresscords);
      this.formData.addressdetails = this.$parent.formData.step2.addressdetails;
    }
    if (this.$parent.formData.step3){
      this.formData = Object.assign(this.formData, this.$parent.formData.step3);
    }
  },
  methods: {
    setAddresscords: function(newAddressCords) {
      this.formData.addresscords = newAddressCords;
    },
    getBookCost: function(itemType) {
      switch (parseInt(itemType)) {
        case 1:
          return 700;
        case 2:
          return 500;
        case 3:
          return 50;
      }
    },
    calcSubtotal: function() {
      let result = 0;
      if (this.$parent.formData.step1){
        result = this.$parent.formData.step1.precio;
      }
      return result;
    },
    calcularentrega: function() {
      if (this.formData.addresscords.lat !== undefined) {
        if (!this.formData.addresscords.address_components){
          this.$bvModal.msgBoxOk(
            "Confirma la dirección presionando sobre el cuadro Dirección de entrega para calcular su ubicación",
            {
              title: "Error",
              size: "sm",
              buttonSize: "sm",
              okVariant: "success",
              headerClass: "p-2 border-bottom-0",
              footerClass: "p-2 border-top-0",
              centered: true
            }
          );
          return;
        }
        
        this.addressInfo = {
          distance: 0,
          localidad: "",
          pais: "",
          provincia: "",
          cpostal: ""
        };

        this.addressInfo.distance = Number.parseFloat(
          this.getDistanceFromLatLonInKm(
            -34.60082,
            -58.395255,
            this.formData.addresscords.lat,
            this.formData.addresscords.lng
          )
        ).toFixed(2);

        let hasNumber = false;
        let locality = null;
        this.formData.addresscords.address_components.forEach(
          function(element) {
            if (element.types.includes("locality")) {
              this.addressInfo.localidad = element.short_name;
            } else if (element.types.includes("administrative_area_level_1")) {
              if (element.short_name === 'CABA') {
                this.addressInfo.localidad = element.short_name;
              }
              this.addressInfo.provincia = element.long_name;
            } else if (element.types.includes("country")) {
              this.addressInfo.pais = element.long_name;
            } else if(element.types.includes("postal_code")){
              this.addressInfo.cpostal = element.short_name;
            } else if(element.types.includes("street_number")){
              hasNumber = true
            } else if (element.types.includes("administrative_area_level_2")) {
              locality = element.long_name
            }
          }.bind(this)
        );
        
        if (
          this.addressInfo.localidad !== 'CABA' && 
          (this.addressInfo.provincia === 'Provincia de Buenos Aires' || this.addressInfo.provincia === 'Buenos Aires')
        ) {
          this.addressInfo.localidad = locality
        }

        if (!hasNumber) {
          this.$bvModal.msgBoxOk(
            "La dirección ingresada parece no tener altura. Si esto no es correcto, por favor revise los datos ingresados y presione 'Calcular entrega' nuevamente.",
            {
              title: "",
              size: "sm",
              buttonSize: "sm",
              okVariant: "success",
              headerClass: "p-2 border-bottom-0",
              footerClass: "p-2 border-top-0",
              centered: true
            }
          );
        }

        if (this.formData.addresscp) {
          this.addressInfo.cpostal = this.formData.addresscp
        }

        this.getShipTypeList();
      } else {
        this.$bvModal.msgBoxOk(
          "Ingrese una dirección para calcular su ubicación",
          {
            title: "Error",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true
          }
        );
      }
    },
    getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
      var R = 6371; // Radius of the earth in km
      var dLat = this.deg2rad(lat2 - lat1); // deg2rad below
      var dLon = this.deg2rad(lon2 - lon1);
      var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.deg2rad(lat1)) *
          Math.cos(this.deg2rad(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c; // Distance in km
      return d;
    },
    deg2rad(deg) {
      return deg * (Math.PI / 180);
    },
    async getShipTypeList(){
       
      await axios
              .post(
              this.$store.state.user.siteData.location + "items/deliverymethods/getAll",
              JSON.stringify(Object.assign({price: this.calcSubtotal(), weigth: this.shipWeight}, this.addressInfo)),
              {
                  validateStatus(status) {
                  return status < 500; // Resolve only if the status code is less than 500
                  },
                  headers: {
                  "Content-Type": "application/json"
                  }
              }
              )
              .then(evtResponse => {
                  console.log(evtResponse.data);
                  this.shipTypeList = [];
                  evtResponse.data.records.forEach(element => {
                    if (element.zonefilter === 0 || element.zonefilter === 1 ){
                      if (parseFloat(element.cost) === 0){
                        this.shipTypeList.push({value: { id: element.id, cost: parseFloat(element.cost)}, text: element.label });
                      }else{
                        this.shipTypeList.push({value: { id: element.id, cost: parseFloat(element.cost)}, text: element.label + ' - ( $' + parseFloat(element.cost) + ')'});
                      }
                    }
                  });
                  this.formData.type = this.shipTypeList[0].value;
                  this.showForm = true;
                  this.stepready = true;
              });

      
    },
    saveData(){
      if (this.formData.deliverytype === '1' && this.formData.type === ''){

        this.$bvModal.msgBoxOk('Debe definir un tipo de envío si quiere recibir el producto', {
          title: 'Error',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
          });
        
        return;
      }
      this.formData.addressInfo = this.addressInfo;
      this.$emit('change', {step3: this.formData});
      this.$router.push('/cart/step4');
    }
  }
};
</script>
